module.exports = __webpack_public_path__ + "static/media/sm-anonymous.8b50dbb9.svg";